export const dataEngagements = [
  { key: 1, label: "Very likely" },
  { key: 2, label: "Likely" },
  { key: 3, label: "Medium" },
  { key: 4, label: "Unlikely" },
  { key: 5, label: "Very unlikely" },
];
